import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../../constants';
import { JobsService } from '../../services/jobs.service';
import ISearchProcessesPaginatedParams = ZoningAPI.ISearchProcessesPaginatedParams;

@Component({
    standalone: false,
    selector: 'app-paginated-jobs-list',
    templateUrl: './paginated-jobs-list.component.html',
    styleUrls: ['./paginated-jobs-list.component.scss']
})
export class PaginatedJobsListComponent implements OnInit {
    @Input()
    jobs$: Observable<ITaskModel[]>;

    @Input()
    totalJobsCount: number;

    @Input()
    getArchived: boolean;

    @Input()
    hideAddButton: boolean;

    @Input()
    showSelectedColumn: boolean;

    @Input() state?: string;

    @Input()
    pageChanged: (event: PageEvent, getArchived: boolean) => void;

    @Input()
    searchParamsChanged: (searchParams: ISearchProcessesPaginatedParams, getArchived: boolean) => void;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(protected readonly jobsService: JobsService) {}

    DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
    DEFAULT_PAGE_SIZE_OPTIONS = DEFAULT_PAGE_SIZE_OPTIONS;

    ngOnInit(): void {}

    resetPagination() {
        if (!this.paginator) {
            return;
        }
        this.paginator.pageIndex = 0;
    }
}
